// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3LLWW","buttons":"SendReceipts_buttons__3cL1z","email":"SendReceipts_email__3Hb3t","bookApptTitle":"SendReceipts_bookApptTitle__2snaa"};